import { OrgData } from 'types/orgs'
import { authorizedGet } from '..'

export type ListOrgsProps = {
  countryCode?: string
}

export type ListOrgResults = {
  results: OrgData[]
}

export const listOrgs = async ({
  countryCode,
}: ListOrgsProps): Promise<ListOrgResults> => {
  try {
    const params = { countryCode }
    const response = await authorizedGet({
      endpoint: `org`,
      params,
    })
    return (await response.json()) as ListOrgResults
  } catch (e) {
    throw e
  }
}
